var exports = {
  "iE": "xaee3c4fa--8ba347--wrapper",
  "P7": "xaee3c4fa--8ba347--inner-wrapper",
  "ld": "xaee3c4fa--8ba347--items",
  "AS": "xaee3c4fa--8ba347--item",
};

module.exports = exports;
